import { useDispatch, useSelector } from "react-redux";
import { setBalance, setUid } from "../redux/slices/userSlice";
import { duringPlay, inPlay } from "../redux/types/userModeTypes";
import {
  changeMatchState,
  changeUserMode,
} from "../redux/slices/userModeSlice";
import { setGameData } from "../redux/slices/gameDataSlice";
import {
  changeBetAmount,
  changeMinesAmount,
  changeAutoBetsNumberOfRounds,
  changeOnWinPercentage,
  changeOnLossPercentage,
  changeIsOnWinReset,
  changeIsOnLossReset,
  setIsInManualMode,
  setSelectedTile,
  changeOnWinStopValue,
  changeOnLossStopValue,
} from "../redux/slices/gameSettingsSlice";
import {
  arrayLength,
  minPercentageOnWinOrLoss,
  maxPercentageOnWinOrLoss,
} from "../config";
import registerApi from "../api/registerApi";
const useRegisterMines = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const localUid = localStorage.getItem("uid");
  const uid = localUid !== undefined ? localUid : user.uid;
  const registerMines = async () => {
    const res = await registerApi(uid);
    if (res !== undefined) {
      dispatch(setUid(res.clientId));
      const currentBalance = parseFloat(res.currentBalance);
      dispatch(setBalance(currentBalance));
      localStorage.setItem("uid", res.clientId);

      if (res.betValue !== null && res.betValue !== undefined) {
        dispatch(changeUserMode(duringPlay));
        dispatch(changeMatchState(inPlay));
        dispatch(setGameData(res));
        dispatch(changeBetAmount(res.betValue));
        dispatch(changeMinesAmount(res.minesCounter));
      } else {
        //take from local storage
        const betAmount = localStorage.getItem("betAmount");
        const minesAmount = localStorage.getItem("minesAmount");
        const autoBetsNumberOfRounds = localStorage.getItem(
          "autoBetsNumberOfRounds"
        );

        const isInManualMode =
          localStorage.getItem("IsInManualMode") === "true";
        const onWinPercentage = parseInt(
          localStorage.getItem("onWinPercentage")
        );
        const onLossPercentage = parseInt(
          localStorage.getItem("onLossPercentage")
        );
        const onWinReset = localStorage.getItem("OnWinReset") === "true";
        const onLossReset = localStorage.getItem("OnLossReset") === "true";
        const selectedTilesTemp = localStorage.getItem("selectedTiles");
        const onWinStopValue = localStorage.getItem("onWinStopValue");
        const onLossStopValue = localStorage.getItem("onLossStopValue");

        const selectedTiles =
          selectedTilesTemp !== undefined && selectedTilesTemp !== null
            ? selectedTilesTemp.split(",").map(Number)
            : [];
        if (betAmount > 0 && betAmount <= currentBalance) {
          dispatch(changeBetAmount(betAmount));
        }
        if (minesAmount > 0 && minesAmount < arrayLength) {
          dispatch(changeMinesAmount(parseInt(minesAmount)));
        }
        if (autoBetsNumberOfRounds > 0) {
          dispatch(
            changeAutoBetsNumberOfRounds(parseInt(autoBetsNumberOfRounds))
          );
        }
        if (
          onWinPercentage > minPercentageOnWinOrLoss &&
          onWinPercentage < maxPercentageOnWinOrLoss
        ) {
          dispatch(changeOnWinPercentage(onWinPercentage));
        }
        if (
          onLossPercentage > minPercentageOnWinOrLoss &&
          onLossPercentage < maxPercentageOnWinOrLoss
        ) {
          dispatch(changeOnLossPercentage(onLossPercentage));
        }
        if (onWinReset != null) {
          dispatch(changeIsOnWinReset(onWinReset));
        }
        if (onLossReset != null) {
          dispatch(changeIsOnLossReset(onLossReset));
        }
        if (isInManualMode != null) {
          dispatch(setIsInManualMode(isInManualMode));
        }
        if (selectedTiles != null && selectedTiles.length > 0) {
          dispatch(setSelectedTile(selectedTiles));
        }
        if (onWinStopValue != null && onWinStopValue >= 0) {
          dispatch(changeOnWinStopValue(onWinStopValue));
        }
        if (onLossStopValue != null && onLossStopValue >= 0) {
          dispatch(changeOnLossStopValue(onLossStopValue));
        }
      }
    }
  };

  return registerMines;
};

export default useRegisterMines;
